import React, { useEffect, Fragment } from "react";
import { withRouter } from "react-router-dom";

function ScrollToTop({ history, children, el }) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      el.scrollTo({ top: 300, behavior: "smooth" });
    });
    return () => {
      unlisten();
    };
  }, []);

  return <Fragment>{children}</Fragment>;
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/js/components/scroll-top/index.js